<template>
    <div class="type mt-4 position-relative">
        <ldc-select
            v-model="new_old"
            placeholder="Chọn dạng bài viết"
            class="rv-select-form" v-if="$detect == 'web'">
            <ldc-option v-for="(v, k) in types" :key="k"
                :value="v.id"
                :label="v.name"/>
        </ldc-select>
        <ldc-select-mobile
            :showPlaceholder="false"
            placeholder="Chọn dạng bài viết"
            title="Loại tin"
            v-model="new_old"
            class="select-mobile-post"
            v-else>
            <ldc-option-mobile v-for="(v, k) in types" :key="k"
               :value="k.id"
               :label="v.name"/>

        </ldc-select-mobile>
        <div class="text-position-select position-absolute text-primary">Dạng bài viết</div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'types','error'],
    data() {
        return {
            new_old: ''
        }
    },
    watch: {
        data(val){
            console.log(val)
            this.new_old = val;
        },
        new_old(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        console.log(this.data)
        this.new_old = this.data;
    }
}
</script>
